<template>
  <!-- NAVIGATION PAGE -->
      <nav
        class="navbar navbar-light m-4"
        style="display: flex; justify-content: space-between"
      >
      <h3>Kanban</h3>

        <div v-if="activePage === 'LoginPage' || activePage === 'Register'" id="navbar-login">
          <button @click.prevent="changePage('Register')" type="button" class="btn btn-primary">Register</button>
          <button @click.prevent="changePage('Login')" type="button" class="btn btn-outline-primary" id="login-btn">
            Login
          </button>
        </div>

        <div v-else-if="activePage === 'Dashboard'" id="navbar-main">
          <button @click.prevent="logout()" type="button" class="btn btn-danger" id="logout-btn">
            Logout
          </button>
        </div>

      </nav>
</template>

<script>
export default {
  name: "Navbar",
  props: ['activePage', "isLogin"],
  methods: {
    changePage(page){
        console.log(page);
      this.$emit("changePage", page)
    },
    logout(){
      this.$emit("logout")
    }
  }
}
</script>

<style>
</style> 